import React from 'react';
import useInView from './useInView';
import useMotionPrefs from './useMotionPrefs';

/* ==================================================================
   WhyMatch
   ------------------------------------------------------------------
   The explanation behind the match score. The ticks draw in sequence
   the first time the card is seen and then stay put - a reason list
   that re-animates every time you scroll past reads as noise, not
   as intelligence.
   ================================================================== */

export default function WhyMatch({ reasons = [], label = 'Why you match', className = '', style }) {
  const { reduced } = useMotionPrefs();
  const [ref, inView] = useInView({ threshold: 0.4, skip: reduced });

  if (!reasons.length) return null;

  return (
    <div
      ref={ref}
      className={`ui-why ${className}`.trim()}
      data-in={inView ? 'true' : 'false'}
      style={style}
    >
      <div className="ui-why__label">{label}</div>
      <div className="ui-why__list">
        {reasons.map((reason, i) => (
          <span key={i} className="ui-why__item" style={{ '--ui-i': i }}>
            <svg className="ui-why__tick" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3.5" aria-hidden="true">
              <polyline points="20 6 9 17 4 12" />
            </svg>
            {reason}
          </span>
        ))}
      </div>
    </div>
  );
}
